import React, { useState, useEffect, Fragment, useMemo } from 'react';
import {
  Marker,
  Polygon,
  InfoWindow,
  Polyline,
} from '@react-google-maps/api';
import { LayerColorIcon } from 'components/Tvendo/Common/LayerCombo';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import LayerLegend from 'components/Tvendo/Common/LayerLegend';
import { LocalShipping, Search, Visibility, GpsFixed } from '@material-ui/icons';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import GridContainer from 'components/Grid/GridContainer';
import Button from 'components/CustomButtons/Button';
import GridItem from 'components/Grid/GridItem';
import { currency, nPercent } from 'hooks/Pipe';
import { wsGetAll } from 'services/WService';
import { Checkbox, FormControlLabel, TextField, ListItemText, Tooltip } from '@material-ui/core';
import { nthIndexOf } from 'hooks/Pipe';
import { wsGet } from 'services/WService';
import { formatDate } from 'hooks/Pipe';
import moment from 'moment';
import GoogleMapCustom from 'components/Tvendo/Common/GoogleMapCustom';
import List from '@material-ui/core/List';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItem from '@material-ui/core/ListItem';
import MultiComplete from 'components/Tvendo/Common/MultiComplete';

function TracingModal(props) {
  const { zoneId, jornada } = props;
  const { open, onClose } = props;

  const [loading, setLoading] = useState(false);
  const [day, setDay] = useState(moment().format('YYYY-MM-DD'));
  const [jornadaActual, setJornadaActual] = useState({ id: 0 });
  const [jornadas, setJornadas] = useState([]);
  const [routes, setRoutes] = useState([]);

  // Mapa
  const [mapZoom, setMapZoom] = useState(13);
  const [mapCenter, setMapCenter] = useState({
    lat: -14.07543457346045,
    lng: -75.73423487506565,
  });
  const [infoData, setInfoData] = useState({
    show: false,
    title: '',
    description: '',
    document: undefined,
  });
  const [showMarkerLabels, setShowMarkerLabels] = useState(false);
  const [showNotAssigned, setShowNotAssigned] = useState(true);
  const [showAddressesAssigned, setShowAddressesAssigned] = useState(true);
  const [showRoutesAssigned, setShowRoutesAssigned] = useState(true);
  const [gps, setGps] = useState([]);
  const [showGps, setShowGps] = useState(false);
  const [base_zone_id, setZones] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [selectedJornada, setSelectedJornadas] = useState([]);
  const [MBusqueda, setMBusqueda] = useState(false);

  async function fetchData() {
    if (!open || jornada.id === undefined || zoneId === undefined) return;

    setLoading(true);
    let response = await wsGetAll(`deliv/jornada/zone-data?base_zone_id=${zoneId}&day=${day}`);
    setLoading(false);
    if (!response.success) return alert(response.message);

    setJornadas(response.data.jornadas);
    setRoutes(
      response.data.routes.map((route) => {
        if (route.geometry !== null) {
          route.geometry = route.geometry.value.map((polygon) => {
            return polygon.map((point) => ({
              lng: point[0],
              lat: point[1],
            }));
          });
        }
        return route;
      }),
    );
  }
 console.log("JORNDAS SELECCIONADAS: ", selectedJornada, " - ", MBusqueda);
  // async function loadGps() {
  //   setGps([]);
  //   if (jornadaActual === undefined) return;
  //   let res = await wsGet('deliv/jornada', jornadaActual?.id);
  //   if (res.success) {
  //     setGps(
  //       res.data.gps.map((gps) => ({
  //         ...gps,
  //         lat: parseFloat(gps.latitude),
  //         lng: parseFloat(gps.longitude),
  //       })),
  //     );
  //   }
  // }

  async function loadMultipleGps() {
    setGps([]);

    if (selectedJornada.length === 0) return;

    const ids = selectedJornada.map(j => j.usuario_id).join(',');
    const res = await wsGet(`deliv/jornada-show/${ids}?&day=${day}`);

    if (res.success && Array.isArray(res.data)) {
      const gpsData = res.data.flatMap(jornada =>
        (jornada.gps || []).map(gps => ({
          ...gps,
          lat: parseFloat(gps.latitude),
          lng: parseFloat(gps.longitude),
          jornadaId: String(gps.jornada_id),
        }))
      );

      setGps(gpsData);
    }
  }

  async function listZones() {
    let res = await wsGetAll('base/zone');
    if (res.success) {
      setZones(res.data);
      const defaultZone = res.data.find((z) => String(z.id) === String(zoneId));
      setSelectedZones(defaultZone ? [defaultZone] : []);
    }
  }

  const jornadasOptions = useMemo(() => {
    if (jornadas.length === 0) return [];

    const selectedZoneIds = selectedZones.map((z) => String(z.id));

    const filteredJornadas = jornadas.filter((j) => {
      const zoneId = j.vehicle?.base_zone_id ? String(j.vehicle.base_zone_id) : null;
      return zoneId && selectedZoneIds.includes(zoneId);
    });
    
    return filteredJornadas.map((j) => {
      const hojas = j.hojas.map((h) => h.prog_sheet_distribution_id).join(', ');
      const vehiculo = j.vehicle ? `Camión: ${j.vehicle.code}` : 'Sin vehículo';
      const usuario = j.usuario?.nombre || 'Sin usuario';
      const clientes = j.resumen?.clientes || 0;

      const label = `ID: ${j.id} | JR ${usuario} | ${vehiculo} | HR (${hojas}) | Clientes: ${clientes}`;

      return {
        ...j,
        displayLabel: label,
        selectionKey: j.usuario_id,
      };
    });
  }, [jornadas, selectedZones]);

  useEffect(() => {
    if (open) {
      fetchData();
    }
  }, [open, zoneId, jornada]);
  
  useEffect(() => {
    if(jornadas.length > 0 && !MBusqueda){
      listZones();
    }
  }, [jornadas]);

  useEffect(() => {
    if (selectedJornada.length > 0) {
      const validIds = jornadasOptions.map((j) => j.usuario_id);
      const stillValid = selectedJornada.filter((j) => validIds.includes(j.usuario_id));

      if (stillValid.length === 0) {
        setSelectedJornadas([]);
      }
    }
  }, [jornadasOptions]);

  useEffect(() => {
    if (jornadas.length === 0) return;
    if (jornada?.id) {
      return setJornadaActual(jornadas.find((item) => item.usuario_id === jornada.usuario_id));
    }
    setJornadaActual({ id: 0 });
  }, [jornada, jornadas]);

  useEffect(() => {
    if (jornadas.length > 0 && selectedJornada.length === 0 /*&& jornadasOptions.length > 0*/) {
      if (!MBusqueda) {
        console.log("ENTRO LA BUSQUEDA");
        if (jornadaActual && jornadaActual.usuario_id) {
          const found = jornadasOptions.find(j => j.usuario_id === jornadaActual.usuario_id);
          console.log("REGISTRO ENCONTRADO: ", found);
          if (found) {
            setSelectedJornadas([found]);
          }
        }
      }
      else {
        const jefes = jornadasOptions.filter(j => j.vehicle && j.vehicle.id);
        console.log("JEFES DEL ELSE: ", jefes);
        if (jefes.length > 0) {
          setSelectedJornadas(jefes);
        }
      }
    }
  }, [jornadas, jornadasOptions, MBusqueda]);

  useEffect(() => {
    if (MBusqueda && selectedJornada.length > 0 && jornadasOptions.length > 0) {
      const updatedSelection = selectedJornada
        .map(selected => jornadasOptions.find(opt => opt.usuario_id === selected.usuario_id))
        .filter(Boolean);

      if (updatedSelection.length > 0) {
        const hasChanges = updatedSelection.some((updated, index) => 
          JSON.stringify(updated) !== JSON.stringify(selectedJornada[index])
        );
        
        if (hasChanges) {
          setSelectedJornadas(updatedSelection);
        }
      }
    }
  }, [jornadasOptions, MBusqueda]);

  useEffect(() => {
    if (selectedJornada.length === 0) return;
    loadMultipleGps();
  }, [selectedJornada]);

  useEffect(() => {
    if (jornadaActual === undefined) return;
    if (jornadaActual?.id === 0) return;
    if (routes.length === 0) return;

    let firstRoute = routes.find((route) => route.jornadas.includes(jornadaActual?.usuario_id));
    if (firstRoute === undefined) return;
    setMapCenter({
      lat: firstRoute.centroid.value[1],
      lng: firstRoute.centroid.value[0],
    });
  }, [routes, jornadaActual]);

  useEffect(() => {
    if (!!jornada.dia && jornada.dia !== day) {
      setDay(jornada.dia);
    }
  }, [jornada.dia]);

  return (
    <ModalFull
      title={`Seguimiento de jefe reparto`}
      open={open}
      setOpen={onClose}
      containerStyle={{ height: 'calc(100% - 70px)' }}
    >
      <GridContainer style={{ height: '100%' }}>
        <GridItem xs={12}>
          <GridContainer>
            <GridItem xs={12} lg={6} style={{ margin: 0 }}>
              <LayerLegend
                title={'Poligonos'}
                style={{ margin: 0, marginTop: '10px' }}
                usePropsLayer
                layers={[
                  { color: '#0000FF', name: 'Rutas asignadas' },
                  { color: '#000000', name: 'Rutas no asignadas' },
                ]}
              />
            </GridItem>

            {/* Leyenda */}
            <GridItem xs={12} lg={6} style={{ margin: 0 }}>
              <LayerLegend
                title={'Marcadores'}
                style={{ margin: 0, marginTop: '10px' }}
                type="image"
                usePropsLayer
                layers={[
                  { color: '/img/marcadores/plomo.png', name: 'De otro usuario' },
                  { color: '/img/marcadores/amarillo.png', name: 'Pendiente' },
                  { color: '/img/marcadores/verde.png', name: 'Entregado' },
                  { color: '/img/marcadores/naranja.png', name: 'Parcial' },
                  { color: '/img/marcadores/rojo.png', name: 'Anulado' },
                  { color: '/img/marcadores/azul.png', name: 'Punto de liquidación' },
                  { color: '/img/ping.png', name: 'Inicio gps' },
                  { color: '/img/pingEnd.png', name: 'Último gps' },
                ]}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
        {/* Mapa */}
        <GridItem xs={12} md={6}>
          <GridContainer style={{ height: '100%' }}>
            {/* Checkbox */}
            <GridItem xs={12} style={{ marginBottom: '5px' }}>
              <FormControlLabel
                label="Mostrar nombres"
                control={
                  <Checkbox
                    margin="normal"
                    checked={showMarkerLabels}
                    onChange={(e) => setShowMarkerLabels(e.target.checked)}
                  />
                }
              />
              <FormControlLabel
                label="Ver rutas/dir no asignados"
                control={
                  <Checkbox
                    margin="normal"
                    checked={showNotAssigned}
                    onChange={(e) => setShowNotAssigned(e.target.checked)}
                  />
                }
              />
              <FormControlLabel
                label="Ver gps"
                control={
                  <Checkbox
                    margin="normal"
                    checked={showGps}
                    onChange={(e) => setShowGps(e.target.checked)}
                  />
                }
              />

              <FormControlLabel
                label="Ver dir asignadas"
                control={
                  <Checkbox
                    margin="normal"
                    checked={showAddressesAssigned}
                    onChange={(e) => setShowAddressesAssigned(e.target.checked)}
                  />
                }
              />

              <FormControlLabel
                label="Ver rutas asignada"
                control={
                  <Checkbox
                    margin="normal"
                    checked={showRoutesAssigned}
                    onChange={(e) => setShowRoutesAssigned(e.target.checked)}
                  />
                }
              />

              <TextField
                label="Fecha"
                type="date"
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: moment().format('YYYY-MM-DD') }}
                onChange={(e) => {
                  let value = e.target.value;
                  setDay(value);
                }}
                disabled={loading}
                value={day}
                margin="none"
              />
              <MultiComplete
                label="Zonas"
                selectAll
                limitTags={1}
                textField="description"
                options={base_zone_id}
                // disabled={processing
                selected={selectedZones}
                setSelected={setSelectedZones}
              />
              <MultiComplete
                label="Jefe de Jornada"
                selectAll
                limitTags={1}
                textField="displayLabel"
                valueField="selectionKey"
                options={jornadasOptions}
                selected={selectedJornada}
                setSelected={setSelectedJornadas}
              />
              {/* <span style={{ fontWeight: 'bold' }}>{jornada.id} </span>
              JR: {jornada.usuario.nombre}
              {jornada.vehicle && ` Camión: ${jornada.vehicle.code}`}
              <span style={{ fontWeight: 'bold' }}>
                {' '}
                HR: ({jornada.hojas.map((hoja) => hoja.prog_sheet_distribution_id).join(', ')})
              </span>
              <RightSpan>Clientes: {jornada.resumen.clientes}</RightSpan> */}

              <Button
                justIcon
                color="success"
                round
                size="small"
                disabled={loading}
                onClick={() => {setMBusqueda(true); fetchData();}}
              >
                <Search />
              </Button>
            </GridItem>
            {/* Mapa */}
            <GridItem xs={12} style={{ height: 'calc(100% - 170px)' }}>
              <GoogleMapCustom
                mapContainerStyle={{
                  width: '100%',
                  height: '100%',
                  minHeight: '500px',
                }}
                zoom={mapZoom}
                center={mapCenter}
                options={{
                  disableDoubleClickZoom: true,
                }}
                onClick={() => {
                  if (infoData.show)
                    setInfoData({
                      show: false,
                      title: '',
                      description: '',
                    });
                }}
              >
                {/* Rutas */}
                {routes.map((route) => {
                  if (route.geometry === null) return null;

                  const selectedIds = selectedJornada.length > 0 ? selectedJornada.map(j => String(j.id)) : [String(jornadaActual?.id)];
                  const coincidencias = route.jornadas.filter(rj => selectedIds.includes(String(rj)));
                  const cantidadCoincidencias = coincidencias.length;

                  let ColorFill = undefined;
                  if (cantidadCoincidencias === 1) ColorFill = 'blue';
                  else if (cantidadCoincidencias > 1) ColorFill = '#ae00ff';

                  const isAssigned = cantidadCoincidencias > 0;
                  if (showNotAssigned === false && !isAssigned) return null;
                  if (showRoutesAssigned === false && isAssigned) return null;

                  return (
                    <Polygon
                      key={route.id}
                      options={{
                        fillColor: ColorFill,
                      }}
                      paths={route.geometry}
                      onDblClick={() => {
                        setInfoData({
                          show: true,
                          lat: route.centroid.value[1],
                          lng: route.centroid.value[0],
                          title: route.code,
                          description: route.description,
                        });
                      }}
                    />
                  );
                })}

                {infoData.show && (
                  <InfoWindow
                    position={{ lat: infoData.lat, lng: infoData.lng }}
                    onCloseClick={() => setInfoData({ show: false, description: '', title: '', document: undefined, })}
                    options={{
                      pixelOffset: {
                        width: 0,
                        height: -25,
                      },
                    }}
                  >
                    <div>
                      <h4>{infoData.title}</h4>
                      <h5>{infoData.description}</h5>
                      {infoData.document !== undefined && (
                        <>
                          <h5>
                            {infoData.document.DocStatus === 'O' ? 'Por liquidar' : 'Liquidado'}
                          </h5>
                          {infoData.document.fecusu !== null && (
                            <h5>{formatDate(infoData.document.fecusu)}</h5>
                          )}
                        </>
                      )}
                    </div>
                  </InfoWindow>
                )}
                {/* Direcciones asignadas */}
                {showAddressesAssigned && (
                  (selectedJornada.length > 0 ? selectedJornada : [jornadaActual])
                    .filter(jr => !!jr?.clientes)
                    .flatMap(jr => jr.clientes)
                    .filter(doc => doc.latitude !== '0' && doc.latitude !== null && doc.longitude !== null)
                    .filter((doc, index, self) => index === self.findIndex(d => d.CardCode === doc.CardCode))
                    .map((document, i) => {
                      const isLiquidado = document.DocStatus === 'C' && document.LiqStatus === '1';
                      const isPorLiquidar = document.DocStatus === 'C' && document.LiqStatus === '0';
                      const isAbierto = document.DocStatus === 'O';
                      
                      let iconPath = '/img/marcadores/amarillo.png';
                      if (isLiquidado) iconPath = '/img/marcadores/rojo.png';
                      else if (isPorLiquidar) iconPath = '/img/marcadores/verde.png';
                      else if (document.LiqStatus !== '0' && document.LiqStatus !== '1') iconPath = '/img/marcadores/naranja.png';

                      return (
                        <Fragment key={i}>
                          {/* Dirección principal */}
                          <Marker
                            position={{
                              lat: parseFloat(document.latitude),
                              lng: parseFloat(document.longitude),
                            }}
                            onClick={() =>
                              setInfoData({
                                show: true,
                                lat: parseFloat(document.latitude),
                                lng: parseFloat(document.longitude),
                                title: document.CardName,
                                document: document,
                                description: `(${document.CardCode}) ${document.Street}`,
                              })
                            }
                            icon={iconPath}
                            options={{
                              label: showMarkerLabels
                                ? {
                                    color: 'white',
                                    className: 'map-label',
                                    text:
                                      nthIndexOf(document.CardName, ' ', 2) !== -1
                                        ? document.CardName.substr(
                                            0,
                                            nthIndexOf(document.CardName, ' ', 2),
                                          )
                                        : document.CardName,
                                  }
                                : undefined,
                            }}
                          />

                          {/* Punto de liquidación */}
                          {document.ref_latitude !== null && document.ref_longitude !== null && (
                            <Marker
                              position={{
                                lat: parseFloat(document.ref_latitude),
                                lng: parseFloat(document.ref_longitude),
                              }}
                              onClick={() =>
                                setInfoData({
                                  show: true,
                                  lat: parseFloat(document.ref_latitude),
                                  lng: parseFloat(document.ref_longitude),
                                  title: document.CardName,
                                  document: document,
                                  description: `(${document.CardCode}) ${document.Street}`,
                                })
                              }
                              icon="/img/marcadores/azul.png"
                            />
                          )}
                        </Fragment>
                      );
                    })
                )}
                {/* Direcciones no asignadas */}
                {showNotAssigned && (
                  jornadas
                    .filter((jornada) => {
                      const selectedIds = selectedJornada.length > 0
                        ? selectedJornada.map(j => String(j.id))
                        : [String(jornadaActual?.id)];
                      return !selectedIds.includes(String(jornada.id));
                    })
                    .flatMap((jornada) =>
                      (jornada.clientes || [])
                        .filter(doc => doc.latitude !== '0' && doc.latitude !== null && doc.longitude !== null)
                        .map((document, i) => (
                          <Marker
                            key={`${jornada.id}-${i}`}
                            position={{
                              lat: parseFloat(document.latitude),
                              lng: parseFloat(document.longitude),
                            }}
                            onClick={() =>
                              setInfoData({
                                show: true,
                                lat: parseFloat(document.latitude),
                                lng: parseFloat(document.longitude),
                                title: document.CardName,
                                description: `(${document.CardCode}) ${document.Street}`,
                              })
                            }
                            icon={'/img/marcadores/plomo.png'}
                            options={{
                              label: showMarkerLabels
                                ? {
                                    color: 'white',
                                    className: 'map-label',
                                    text:
                                      nthIndexOf(document.CardName, ' ', 2) !== -1
                                        ? document.CardName.substr(
                                            0,
                                            nthIndexOf(document.CardName, ' ', 2),
                                          )
                                        : document.CardName,
                                  }
                                : undefined,
                            }}
                          />
                        ))
                    )
                )}

                {showGps && (
                  <>
                    {(() => {
                      const gpsByJornada = gps.reduce((acc, point) => {
                        if (!acc[point.jornadaId]) acc[point.jornadaId] = [];
                        acc[point.jornadaId].push(point);
                        return acc;
                      }, {});

                      return Object.entries(gpsByJornada).map(([jornadaId, puntos]) => {
                        const jornada = selectedJornada.find((j) => String(j.id) === String(jornadaId));
                        const sorted = [...puntos].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

                        const first = sorted[0];
                        const last = sorted[sorted.length - 1];

                        const hue = Math.floor(Math.random() * 360);
                        const saturation = Math.floor(70 + Math.random() * 30);
                        const lightness = Math.floor(45 + Math.random() * 10);
                        const Colorstroke = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

                        return (
                          <React.Fragment key={jornadaId}>
                            {/* Primer GPS */}
                            {first && (
                              <Marker
                                position={{ lat: first.lat, lng: first.lng }}
                                icon={'/img/ping.png'}
                                onClick={() =>
                                  setInfoData({
                                    show: true,
                                    lat: first.lat,
                                    lng: first.lng,
                                    title: `Primer GPS | Jefe: ${jornada?.usuario?.nombre ?? 'Desconocido'}`,
                                    description: `Jornada #${jornadaId} | ${moment(first.created_at).format('LT')}`,
                                  })
                                }
                              />
                            )}

                            {/* Último GPS */}
                            {last && (
                              <Marker
                                position={{ lat: last.lat, lng: last.lng }}
                                icon={'/img/pingEnd.png'}
                                onClick={() =>
                                  setInfoData({
                                    show: true,
                                    lat: last.lat,
                                    lng: last.lng,
                                    title: `Último GPS | Jefe: ${jornada?.usuario?.nombre ?? 'Desconocido'}`,
                                    description: `Jornada #${jornadaId} | ${moment(last.created_at).format('LT')}`,
                                  })
                                }
                              />
                            )}

                            {/* Todos los puntos GPS */}
                            {sorted.map((p, i) => (
                              <Marker
                                key={`${jornadaId}-gps-${i}`}
                                position={{ lat: p.lat, lng: p.lng }}
                                icon={'/img/point.png'}
                                onClick={() =>
                                  setInfoData({
                                    show: true,
                                    lat: p.lat,
                                    lng: p.lng,
                                    title: `GPS ${i + 1} | ${moment(p.created_at).format('LT')}`,
                                    description: `Jefe: ${jornada?.usuario?.nombre ?? 'Desconocido'} | Jornada #${jornadaId}`,
                                  })
                                }
                              />
                            ))}
                            
                            {/* Línea del recorrido */}
                            <Polyline
                              path={sorted}
                              options={{
                                strokeColor: Colorstroke,
                                strokeOpacity: 0.5,
                                strokeWeight: 3,
                                visible: true,
                              }}
                            />
                          </React.Fragment>
                        );
                      });
                    })()}
                  </>
                )}
              </GoogleMapCustom>
            </GridItem>
          </GridContainer>
        </GridItem>

        {/* Jornadas / Rutas */}
        <GridItem xs={12} md={6} style={{ overflowY: 'scroll', height: '100%' }}>
          {/* Jornadas actual */}
          <CardContainer
            title="Jornadas seleccionadas"
            cardBodyStyle={{ maxHeight: '300px', overflowY: 'auto' }}
          >
          {(selectedJornada.length > 0 ? selectedJornada : jornadas).map((jr) => { const gpsDeJornada = gps.filter((g) => String(g.jornada_id) === String(jr.id));

            const totalDistance = gpsDeJornada.reduce((sum, g) => {const d = Number(g?.distance);
              return sum + (isNaN(d) ? 0 : d);}, 0);

            const formattedDistance = totalDistance >= 1000 ? `${(totalDistance / 1000).toFixed(2)} km` : `${(totalDistance || 0).toFixed(0)} m`;

            return (
              <div key={jr.id} style={{ marginBottom: '1rem', borderBottom: '1px solid #ddd', paddingBottom: '0.5rem' }}>
                <h4 style={{ marginBottom: '0.5rem' }}>
                  Jornada #{jr.id} | {jr.usuario?.nombre || 'Sin usuario'}
                </h4>

                <ul>
                  <li>
                    Clientes atendidos:{' '}
                    <RightSpan>{`${jr.resumen?.clientesAtendidos || 0} / ${jr.resumen?.clientes || 0}`}</RightSpan>
                  </li>
                  <li>
                    Documentos atendidos:{' '}
                    <RightSpan>{`${jr.resumen?.documentosAtendidos || 0} / ${jr.resumen?.documentos || 0}`}</RightSpan>
                  </li>
                  <li>
                    Soles efectivos:{' '}
                    <RightSpan>{`${currency(jr.resumen?.solesEfectivos)} / ${currency(jr.resumen?.total)}`}</RightSpan>
                  </li>
                  <li>
                    Completos:{' '}
                    <RightSpan>{`${jr.resumen?.documentosCompletos || 0} / ${currency(jr.resumen?.solesCompletos)}`}</RightSpan>
                  </li>
                  <li>
                    Anulados:{' '}
                    <RightSpan>{`${jr.resumen?.documentosAnulados || 0} / (${currency(jr.resumen?.solesAnulados)})`}</RightSpan>
                  </li>
                  <li>
                    Parciales:{' '}
                    <RightSpan>{`${jr.resumen?.documentosParciales || 0} / (${currency(jr.resumen?.solesParciales)})`}</RightSpan>
                  </li>
                  <li>
                    Sin atender:{' '}
                    <RightSpan>{`${jr.resumen?.documentosNoAtendidos || 0} / (${currency(jr.resumen?.solesNoAtendidos)})`}</RightSpan>
                  </li>
                  <li>
                    Efectividad soles:{' '}
                    <RightSpan>{`${nPercent(jr.resumen?.efectividadSoles)}`}</RightSpan>
                  </li>
                  <li>
                    Efectividad pedidos:{' '}
                    <RightSpan>{`${nPercent(jr.resumen?.efectividadPedidos)}`}</RightSpan>
                  </li>
                  <li>
                    Inicio Jornada:{' '}
                    <RightSpan>
                      {!!jr.hora_apertura ? moment(jr.hora_apertura).format('LT') : '-'}
                    </RightSpan>
                  </li>
                  <li>
                    Primera interacción:{' '}
                    <RightSpan>
                      {!!jr.primera_interaccion ? moment(jr.primera_interaccion).format('LT') : '-'}
                    </RightSpan>
                  </li>
                  <li>
                    Primera liquidación:{' '}
                    <RightSpan>
                      {!!jr.primera_liquidacion ? moment(jr.primera_liquidacion).format('LT') : '-'}
                    </RightSpan>
                  </li>
                  <li>
                    Distancia total recorrida:{' '}
                    <RightSpan>{formattedDistance}</RightSpan>
                  </li>
                </ul>
              </div>
            );
          })}
        </CardContainer>
        {/* jornadaActual?.id !== undefined && !!jornadaActual?.clientes && ( */}
          {/* Documentos */}
          <CardContainer
            title="Documentos"
            cardBodyStyle={{ maxHeight: '300px', overflowY: 'auto' }}
          >
            {(selectedJornada.length > 0 ? selectedJornada : jornadas).map((jr) => {
              const documentos = Array.isArray(jr.clientes) ? jr.clientes : [];

              if (documentos.length === 0) return null;

              return (
                <div
                  key={jr.id}
                  style={{
                    marginBottom: '1rem',
                    borderBottom: '1px solid #ddd',
                    paddingBottom: '0.5rem',
                  }}
                >
                  <h4 style={{ marginBottom: '0.5rem' }}>
                    Jornada #{jr.id} | {jr.usuario?.nombre || 'Sin usuario'} |{' '}
                    {documentos.length} documentos
                  </h4>

                  {documentos.map((document, index) => {
                    const colorMarker =
                      document.DocStatus === 'C'
                        ? document.LiqStatus === '1'
                          ? '/img/marcadores/rojo.png'
                          : document.LiqStatus === '0'
                            ? '/img/marcadores/verde.png'
                            : '/img/marcadores/naranja.png'
                        : '/img/marcadores/amarillo.png';

                    return (
                      <CardContainer
                        key={document.DocEntry ?? `${jr.id}-${index}`}
                        icon={null}
                        style={{ marginTop: 5, marginBottom: 5 }}
                        cardBodyStyle={{ padding: 0 }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          {/* 📍 Marcador principal */}
                          <span
                            onClick={() => {
                              setInfoData({
                                show: true,
                                lat: parseFloat(document.latitude),
                                lng: parseFloat(document.longitude),
                                title: document.CardName,
                                document,
                                description: `(${document.CardCode}) ${document.Street}`,
                              });
                            }}
                          >
                            <img src={colorMarker} style={{ cursor: 'pointer' }} />
                          </span>

                          {/* 📏 Distancia */}
                          <span
                            style={{
                              fontSize: '15px',
                              minWidth: '80px',
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            {!document.distance ? '-' : `${document.distance} m`}
                          </span>

                          {/* 🔵 Punto de liquidación */}
                          <span
                            onClick={() => {
                              if (!document.ref_latitude || !document.ref_longitude) {
                                window.alert('No hay punto de liquidación');
                                return;
                              }
                              setInfoData({
                                show: true,
                                lat: parseFloat(document.ref_latitude),
                                lng: parseFloat(document.ref_longitude),
                                title: document.CardName,
                                document,
                                description: `(${document.CardCode}) ${document.Street}`,
                              });
                            }}
                          >
                            <img src="/img/marcadores/azul.png" style={{ cursor: 'pointer' }} />
                          </span>

                          {/* 🧾 Datos del documento */}
                          <div style={{ display: 'flex' }}>
                            <span style={{ marginRight: '35px' }}>
                              {index + 1} → {document.CardName}
                            </span>
                            <span style={{ marginRight: '35px' }}>
                              {document.route_description} | {document.SlpName}
                            </span>
                            <span>{moment(document.fecusu).format('LT')}</span>
                          </div>
                        </div>
                      </CardContainer>
                    );
                  })}
                </div>
              );
            })}
          </CardContainer>
        {/* )} */}
          {/* Gps */}
          <CardContainer
            title="GPS Jefe Reparto"
            cardBodyStyle={{ maxHeight: '200px', overflowY: 'auto' }}
          >
            {(selectedJornada.length > 0 ? selectedJornada : jornadas).map((jr) => {
              const gpsDeJornada = gps.filter(g => String(g.jornada_id) === String(jr.id));

              if (gpsDeJornada.length === 0) return null;

              return (
                <div
                  key={jr.id}
                  style={{
                    marginBottom: '1rem',
                    borderBottom: '1px solid #ddd',
                    paddingBottom: '0.5rem',
                  }}
                >
                  <h4 style={{ marginBottom: '0.5rem' }}>
                    Jornada #{jr.id} | {jr.usuario?.nombre || 'Sin usuario'} | {gpsDeJornada.length} puntos
                  </h4>

                  <List dense>
                    {gpsDeJornada.map((punto, i) => (
                      <ListItem
                        button
                        key={`${jr.id}-${i}`}
                        onClick={() =>
                          setInfoData({
                            show: true,
                            lat: punto.lat,
                            lng: punto.lng,
                            title: `GPS Jornada #${jr.id}`,
                            description: moment(punto.created_at).format('LT'),
                          })
                        }
                      >
                        <ListItemIcon>
                          <GpsFixed />
                        </ListItemIcon>
                        <ListItemText
                          primary={`Hora: ${formatDate(punto.created_at, 'H')}`}
                          secondary={`Lat: ${punto.lat.toFixed(4)} | Lng: ${punto.lng.toFixed(4)}`}
                        />
                      </ListItem>
                    ))}
                  </List>
                </div>
              );
            })}

          </CardContainer>

          {/* Jornadas */}

          {/* <CardContainer
            title={`Jornadas (${jornadas.length})`}
            cardBodyStyle={{ maxHeight: '200px', overflowY: 'auto' }}
          >
            {jornadas.map((jornada) => {
              return (
                <CardContainer
                  key={jornada.id}
                  icon={null}
                  style={{ marginTop: '5px', marginBottom: '5px' }}
                  cardBodyStyle={{
                    padding: '0',
                    backgroundColor: jornada.id === jornadaActual?.id ? '#a7ffa7' : undefined,
                  }}
                >
                  <Button
                    justIcon
                    round
                    simple
                    color="primary"
                    onClick={() => setJornadaActual(jornada)}
                  >
                    <Visibility />
                  </Button>
                  <span style={{ fontWeight: 'bold' }}>{jornada.id} </span>
                  JR: {jornada.usuario.nombre}
                  {jornada.vehicle && ` Camión: ${jornada.vehicle.code}`}
                  <span style={{ fontWeight: 'bold' }}>
                    {' '}
                    HR: ({jornada.hojas.map((hoja) => hoja.prog_sheet_distribution_id).join(', ')})
                  </span>
                  <RightSpan>Clientes: {jornada.resumen.clientes}</RightSpan>
                </CardContainer>
              );
            })}
          </CardContainer> */}
          {/* Rutas */}
          <CardContainer
            title={`Rutas (${routes.length})`}
            cardBodyStyle={{ maxHeight: '200px', overflowY: 'auto' }}
          >
            {(selectedJornada.length > 0 ? selectedJornada : jornadas).map((jr) => {
              const rutasDeJornada = routes.filter((route) => route.jornadas.includes(jr.id));
              if (rutasDeJornada.length === 0) return null;
              return (
                <div
                  key={jr.id}
                  style={{
                    marginBottom: '1rem',
                    borderBottom: '1px solid #ddd',
                    paddingBottom: '0.5rem',
                  }}
                >
                  <h4 style={{ marginBottom: '0.5rem' }}>
                    Jornada #{jr.id} | {jr.usuario?.nombre || 'Sin usuario'} | Rutas asignadas: {rutasDeJornada.length}
                  </h4>
                  {rutasDeJornada.map((route) => {
                    const jornadasSeleccionadas = selectedJornada.length > 0 ? selectedJornada : jornadas;
                    const idsJornadasSeleccionadas = jornadasSeleccionadas.map((j) => j.id);
                    const cantidadJornadasCoincidentes = route.jornadas.filter((jid) =>
                      idsJornadasSeleccionadas.includes(jid)
                    ).length;

                    let color = '#000000';
                    if (cantidadJornadasCoincidentes === 1) color = '#0000FF';
                    else if (cantidadJornadasCoincidentes > 1) color = '#ae00ff';

                    return (
                      <RouteCard
                        key={route.id}
                        route={route}
                        color={color}
                        setInfoData={setInfoData}
                        jornadas={jornadas}
                        setJornadaActual={setJornadaActual}
                      />
                    );
                  })}
                </div>
              );
            })}

            {/* Rutas que no tienen la jornada actual */}
            {(() => {
              const jornadasMostradas = selectedJornada.length > 0 ? selectedJornada : jornadas;
              const idsJornadasMostradas = jornadasMostradas.map((jr) => jr.id);
              const rutasDeJornadasMostradas = routes.filter((route) => route.jornadas.some((jid) => idsJornadasMostradas.includes(jid)));
              const idsRutasMostradas = rutasDeJornadasMostradas.map((r) => r.id);
              let rutasSinJornadaActual = routes.filter((route) => !route.jornadas.includes(jornadaActual?.id) && !idsRutasMostradas.includes(route.id));
              if (!showNotAssigned) rutasSinJornadaActual = [];
              const totalRutasSinJornada = rutasSinJornadaActual.length;
              return (
                <>
                  <h4 style={{ marginBottom: '0.5rem', marginTop: '1rem' }}>
                    Rutas sin jornada actual: {totalRutasSinJornada}
                  </h4>

                  {rutasSinJornadaActual.map((route) => (
                    <div key={route.id} style={{ marginBottom: '1rem' }}>
                      <RouteCard
                        route={route}
                        color="#000000"
                        setInfoData={setInfoData}
                        jornadas={jornadas}
                        setJornadaActual={setJornadaActual}
                      />
                    </div>
                  ))}
                </>
              );
            })()}
          </CardContainer>
        </GridItem>
      </GridContainer>
    </ModalFull>
  );
}

function RightSpan({ children }) {
  return <span style={{ float: 'right' }}>{children}</span>;
}

function RouteCard({ route, setInfoData, color, jornadas, setJornadaActual }) {
  return (
    <CardContainer
      icon={null}
      style={{ marginTop: '5px', marginBottom: '5px' }}
      cardBodyStyle={{
        padding: '0',
        position: 'relative',
      }}
    >
      {route.description}
      <Button
        justIcon
        round
        simple
        color="primary"
        onClick={() => {
          setInfoData({
            show: true,
            lat: route.centroid.value[1],
            lng: route.centroid.value[0],
            title: route.code,
            description: route.description,
          });
        }}
      >
        <Visibility />
      </Button>
      <LayerColorIcon layer={{ color: color }} style={{ display: 'inline-block' }} />
      <div
        style={{
          position: 'absolute',
          backgroundColor: '#00000055',
          borderRadius: '5px',
          right: '5px',
          top: '50%',
          transform: 'translateY(-50%)',
          height: '35px',
        }}
      >
        {route.jornadas.map((jornadaId, index) => {
          let color = 'green';
          if (index == 1) {
            color = 'yellow';
          } else if (index > 1) {
            color = 'red';
          }
          return (
            <Tooltip
              title={jornadaId}
              key={jornadaId}
              onClick={() => {
                setJornadaActual(jornadas.find((jornada) => jornada.id === jornadaId));
              }}
            >
              <LocalShipping htmlColor={color} style={{ margin: '5px', cursor: 'pointer' }} />
            </Tooltip>
          );
        })}
      </div>
    </CardContainer>
  );
}

export default TracingModal;
